import { isMobile } from "./isMobile";
import { isIos } from "./isIos";

export const isAndroid = isMobile && !isIos;
